import { Menu as AntMenu } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import { theme } from '../../theme/semanticTokens';
import { Typography } from '../../Typography';

export const StyledMenu = styled(AntMenu)`
  &&& {
    background-color: transparent;
    border: none;
    padding: 0;
    min-width: 180px;

    &.ant-menu {
      background: transparent;
      border: none;
      min-width: 180px;
    }

    .ant-menu-item {
      margin: 0 0 4px 0;
      min-width: 180px;
      width: 100%;
      height: 32px;
      padding: ${theme.dime.spacing.m};
      border-radius: ${theme.dime.radius.s};
      display: flex;
      align-items: center;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .ant-menu-submenu-title {
      min-width: 180px;
      width: 100%;

      .ant-menu-title-content {
        width: 100%;
      }
    }

    .ant-menu-item-divider {
      margin: ${theme.dime.spacing.m} 0;
      border-color: ${theme.dime.colors.border.static};
      border-top: 1px solid ${theme.dime.colors.border.static};
      border-bottom: none;
    }

    &.ant-menu-vertical {
      border-right: none;
      border: none;
    }
  }
`;

export const MenuTitle = styled(Typography)`
  &&& {
    color: ${theme.dime.colors.text.secondary};
    margin-bottom: ${theme.dime.spacing.m};
    padding: ${theme.dime.spacing.m} ${theme.dime.spacing.m} ${theme.dime.spacing.s}
      ${theme.dime.spacing.m};
    display: block;
    line-height: ${theme.dime.fonts.lineHeights.xs};
  }
`;

export const MenuContainer = styled.div`
  background-color: ${theme.dime.colors.surface.primary};
  border-radius: ${theme.dime.radius.m};
  border: 1px solid ${theme.dime.colors.border.static};
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.08);
  padding: ${theme.dime.spacing.s};

  width: 100%;
  min-width: 180px;
  overflow: hidden;
`;

export const SubMenuPopupGlobalStyles = createGlobalStyle`
  .ant-menu-submenu-popup.dime-menu-submenu-popup {
    .ant-menu.ant-menu.ant-menu {
      background-color: ${theme.dime.colors.surface.primary};
      border-radius: ${theme.dime.radius.m};
      border: 1px solid ${theme.dime.colors.border.static};
      box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.08);
      padding: ${theme.dime.spacing.s};
      margin: ${theme.dime.spacing.s};
      overflow: hidden;
      min-width: 180px;

      .ant-menu-item.ant-menu-item.ant-menu-item {
        min-width: 180px;
        width: 100%;
        margin: 0 0 4px 0;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
`;
